import React from 'react';

import { Wrapper, MainText, SubText, Button } from './styles';

const Banner: React.FC = () => {
  return (
    <Wrapper>
      <MainText>Interested in Mobile App?</MainText>
      <SubText>
        Get access to the OPUS Notifer mobile app to monitor your playlists and
        tracks.
      </SubText>
      <Button to="/downloadOpusNotifierApp">Get Notifier App</Button>
    </Wrapper>
  );
};

export default Banner;
